export default "__VITE_ASSET__BivflTyL__"